import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { ifProp } from 'styled-tools';

import { minWidth } from '@calm-web/design-system';

import FullscreenBackground from '@/components/image/FullscreenBackground';

const stretchedBg = css`
	& img {
		transform: translateX(-40%);
		width: 180%;

		${minWidth('tablet')} {
			transform: translateX(0);
			width: 100%;
		}
	}
`;

const distanceFromBottom = '124px';

const grayFade = css`
	& img {
		height: calc(100% - ${distanceFromBottom});
		object-position: top;
	}

	&:before {
		background: #545454;
		bottom: 0;
		content: '';
		height: ${distanceFromBottom};
		left: 0;
		right: 0;
		position: absolute;
		z-index: 2;
	}

	&:after {
		background: linear-gradient(rgba(84, 84, 84, 0), #545454 100%);
		bottom: ${distanceFromBottom};
		content: '';
		height: 25vh;
		left: 0;
		position: absolute;
		right: 0;
		z-index: 1;
	}
`;

export const FixedBackground = styled(FullscreenBackground)<{
	isVisible: boolean;
	isStretchedMobile?: boolean;
	hasGrayFade?: boolean;
}>`
	opacity: ${ifProp('isVisible', 1, 0)};
	position: fixed;
	transition: 200ms ease-out;
	z-index: 0;
	visibility: ${ifProp('isVisible', 'visible', 'hidden')};

	${(props): FlattenSimpleInterpolation | string => (props.isStretchedMobile ? stretchedBg : '')}

	${(props): FlattenSimpleInterpolation | string => (props.hasGrayFade ? grayFade : '')}
`;
